import styled from "styled-components";

const StyledPaginationLocal = styled.div`
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
`;

const StyledItemsPage = styled.div`
    font-size: 15px;
    color: #787878;
    padding-right: 2rem !important;
`;

const StyledIndexesAndLength = styled.div`
    font-size: 15px;
    color: #787878;
    padding-right: 2rem !important;
`;

const StyledIcon = styled.div`
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
`;

export {
    StyledPaginationLocal,
    StyledItemsPage,
    StyledIndexesAndLength,
    StyledIcon,
};
